module.exports = __webpack_public_path__ + "img/active.87bd3812.png";